/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

/**
 * Allows for syntax-highlighted GraphQL template strings, when paired with the GraphQL
 * extension in VSCode.
 *
 * e.g.:
 * ```ts
 * // getSomething.query.ts
 * export const getSomethingQuery = gql`
 *      query GetSomethingQuery {
 *          my
 *          fields
 *          here
 *      }
 * `
 * ```
 */
export const gql = String.raw;
    